export class ChunkedData {
    constructor() {
        this._data = [];
        this._data = new Array(ChunkedData.CHUNK_DIMENSIONS.x * ChunkedData.CHUNK_DIMENSIONS.y);
    }
    get(coords) {
        return this._data[coords.chunk_i]?.[coords.tile_i];
    }
    set(coords, v) {
        if (!this._data[coords.chunk_i])
            this._data[coords.chunk_i] = new Array(ChunkedData.CHUNK_SIZE * ChunkedData.CHUNK_SIZE);
        this._data[coords.chunk_i][coords.tile_i] = v;
    }
}
(function (ChunkedData) {
    ChunkedData.CHUNK_SIZE = 64;
    ChunkedData.CHUNK_DIMENSIONS = {
        x: 100,
        y: 200
    };
    function split(coords) {
        let c = {
            x: Math.floor(coords.x / ChunkedData.CHUNK_SIZE),
            y: Math.floor(coords.y / ChunkedData.CHUNK_SIZE),
        };
        let t = {
            x: coords.x % ChunkedData.CHUNK_SIZE,
            y: coords.y % ChunkedData.CHUNK_SIZE,
        };
        return {
            coords: coords,
            chunk: c,
            tile: t,
            chunk_i: c.y * ChunkedData.CHUNK_DIMENSIONS.x + c.x,
            tile_i: t.y * ChunkedData.CHUNK_SIZE + t.x
        };
    }
    ChunkedData.split = split;
})(ChunkedData || (ChunkedData = {}));
